import { ENTRY_ROUTE_NAME_FOR_STAFF, ENTRY_ROUTE_NAME_FOR_OWNERS } from '@/constants/routes'
import { MODULE_SESSION } from '@/store/modules/session/session.types'
import { ROLE_OWNER } from '@/constants/roles'

export default function redirectByPermission({ next, store }) {
  const { role } = store.state[MODULE_SESSION].model
  const name = role === ROLE_OWNER ? ENTRY_ROUTE_NAME_FOR_OWNERS : ENTRY_ROUTE_NAME_FOR_STAFF
  return next({ name })
}
